import React, { useContext } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { GlobalContext } from '../../../App';
import { useSelector } from 'react-redux';
import { DataContext, TemplateContext } from '../pagesMains/GravesManagers/Graves';
import CustomCard from '../../reports/summery/detais_new/details_new';
import useQueryGraves from '../../../database/filters/queriesGrave';
import useQueries from '../../../database/useQueries';
import ColumnOrderingGrid from '../../template/table';
import { onClickRow, mapFieldValues, fixNullValues } from '../plagins/utility';
import { useEffect } from 'react';
import ConfirmationDialog from '../plagins/dialogs/ConfirmationDialog';
import { useState } from 'react';
import { createFetchDataServer, createFetchDataServerWithCallback, fetchDataFromServerFullWithCallback, getTableData } from '../../../database/fetchData';

const CemeteryDetail = () => {
  // קבלת ערכים מהסטור
  const optionsFields = useSelector((state) => state.dataOptionsFieldsHe.data);
  const columns = useSelector((state) => state.columnsTableBlocks.data);
  const properties = useSelector((state) => state.columnsPropertiesCemeteries.data);

  const context = useContext(DataContext);
  const fetchDataServer = createFetchDataServer(context);
  // const fetchDataServerWithCallback = createFetchDataServerWithCallback(context);

  // טעינת היוזים לפונקציות עזר
  const { getSummaryByBlock } = useQueryGraves();
  const { getEntitiesByAttr, getEntityByAttr, removeCemetery } = useQueries();

  const { searchText, setTotalWidthContainer } = useContext(TemplateContext);
  const { token, setBreadcrumbs, setTitle, permission } = useContext(GlobalContext);
  const myPermissions = [1];
  
  const [loading, setLoading] = useState(true); // מצב טעינה

  // ערכי הראוטר
  const navigate = useNavigate();
  const location = useLocation();
  const { value, summaries } = location.state || {};
  const [myCemetery, setMyCemetery] = useState(context?.contextCemeteries?.find(cemetery => cemetery?.unicId === value?.unicId) || value);
  useEffect(() => {
    setMyCemetery(context?.contextCemeteries?.find(cemetery => cemetery?.unicId === value?.unicId) || value)
  }, [context?.contextCemeteries]);


  
  useEffect(() => {
    setTotalWidthContainer(1400);


    setBreadcrumbs([
      { id: 0, name: 'בתי עלמין', url: '/cemetery', state: { myCemetery, summaries } },
      { id: 1, name: myCemetery?.cemeteryNameHe, url: location.pathname, state: location.state }
    ]);
    setTitle(`בית עלמין ${myCemetery?.cemeteryNameHe}`);
  }, [loading, location.pathname]);

  // סטייט לפופאפ האישור
  const [openConfirmDialog, setOpenConfirmDialog] = useState(false);

  const handleButtonUpdate = () => {
    navigate('/cemeteryUpdate', { state: { value: myCemetery } });
  };

  const mappedData = mapFieldValues(
    context?.contextBlocks?.filter((block) => block?.cemeteryId === myCemetery?.unicId),
    optionsFields
  );

  // כאשר המשתמש עונה בדיאלוג
  const handleAnswerDelete = (answer) => {
    setOpenConfirmDialog(false);
    if (answer) {
      context?.setContextCemeteries((prev) => prev.filter((item) => item.unicId !== myCemetery?.unicId));

      removeCemetery({ id: value?.unicId });
      navigate(-1);
    }
  };

  // הסרת אחוזת קבר
  const deleteItem = () => {
    const cemetery = getEntityByAttr(context?.contextCemeteries, 'unicId', value?.unicId);
    const blocks = getEntitiesByAttr(context?.contextBlocks, 'cemeteryId', cemetery?.unicId);

    let checkEntity = blocks;
    if (checkEntity?.length > 0) {
      alert('לא ניתן להסיר, קיים תיק מקושר');
    } else {
      setOpenConfirmDialog(true); // פותח את הדיאלוג לאישור המחיקה
    }
  };

  // טעינת הנתונים
  useEffect(() => {
    async function loadTableData() {
      const localTempData = await getTableData('myDatabase', 'myStore');
      if (localTempData) {
        const dataCemeteries = localTempData.find((item) => item.name === 'dataCemeteries');
        const dataBlocks = localTempData.find((item) => item.name === 'dataBlocks');
        if (dataCemeteries && dataBlocks) {
          setLoading(false);
        }
      }
      else {
        const handlePartialUpdate = (tableName) => {
          console.log(`Partial update received for table: ${tableName}`);
          setLoading(false);
        };
        // fetchDataServerWithCallback(['cemeteries'], token, handlePartialUpdate);
  
        fetchDataServer(['blocks'], token);
      }
    }
    loadTableData();
  }, []);


  return (
    <>
      <CustomCard data={properties} value={context?.contextCemeteries?.find(cemetery => cemetery?.unicId === myCemetery?.unicId)} summaries={summaries} handleEdit={handleButtonUpdate} handleDelete={deleteItem} permission={permission === 0 ? false : !myPermissions.includes(permission)} />
      <ColumnOrderingGrid 
      // rows={mappedData} 
      rows={fixNullValues(mappedData)} 
      columns={columns.filter((prop) => prop.show)} searchText={searchText} onRowSelect={(row) => onClickRow(row, getSummaryByBlock, navigate)} />

      {/* דיאלוג לאישור מחיקה */}
      <ConfirmationDialog open={openConfirmDialog} title="אישור מחיקה" content="האם את/ה בטוח שברצונך להסיר את בית העלמין?" onAnswer={handleAnswerDelete} />
    </>
  );
};

export default CemeteryDetail;
